/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindTritanopia(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindTritanopia',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 13.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2m0 1.4a4 4 0 1 0 0-8 4 4 0 0 0 0 8","fill":"#2496FF"}),createElement('path', {"d":"M6.982 7.863a4 4 0 1 0 0 6.274A5.47 5.47 0 0 1 6 11c0-1.166.363-2.247.982-3.137","fill":"#2FC862"}),createElement('path', {"d":"M11.967 5.516a4 4 0 1 0-5.473 3.19 5.5 5.5 0 0 1 5.473-3.19","fill":"#FF424D"}))
}
